<template>
  <header class="">
    
    <nav class="navbar navbar-expand-sm navbar-light navbar-top">

      <div class="container py-1">
        <router-link :to="{ name: 'hikes' }" class="navbar-brand text-dark" rel="home" title="" itemprop="url">
          <strong class="text-dark">ЗАБУГОРЩИКИ</strong>
        </router-link>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <div class="d-flex align-items-center justify-content-between w-100">        
            <ul class="navbar-nav mx-md-auto">
              <li class="nav-item"><router-link :to="{ name: 'hikes' }" v-if="user" class="nav-link router-link">Походы</router-link></li>
              <li class="nav-item"><router-link :to="{ name: 'chat' }" v-if="user" class="nav-link router-link">Чат</router-link></li>
              <li class="nav-item" v-if="user && user.isAdmin"><router-link :to="{ name: 'gps-tracks' }" class="nav-link router-link" v-if="user" :class="{ 'router-link-exact': isSubjectSection }">GPS-треки</router-link></li>
              <li class="nav-item"><a v-if="user" href="https://instagram.com/zabugorshiki/" class="nav-link" target="_blank">Помощь</a></li>
              <li class="nav-item"><router-link :to="{ name: 'profile-edit' }" class="nav-link router-link" v-if="user"> Профиль</router-link></li>
              <!-- <li class="nav-item"><router-link v-if="user && user.isAdmin" :to="{ name: 'admin-libraries' }" class="router-link" :class="{ 'router-link-exact': isAdminSection }">Admin</router-link></li> -->
              <li class="nav-item d-md-none">
                <a class="nav-link" href="#" @click.prevent="logout()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-log-out"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                  Выйти
                </a>
              </li>
            </ul>

            <div class="text-right" v-if="!isLogged">
              <ul class="navbar-nav">
                <li class="nav-item mr-3">
                  <router-link :to="{ name: 'login' }">Вход</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'register' }">Регистрация</router-link>
                </li>
              </ul>
            </div>
            <div class="text-right d-none d-md-block" v-else>
              <ul class="navbar-nav">
                <li class="nav-item">
                  <a class="nav-link" href="#" @click.prevent="logout()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-log-out"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                    Выйти
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </b-collapse><!-- .container -->
      </div>

    </nav><!-- .site-navigation -->

  </header>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'app-header',
  data () {
    return {
      showAccountModal: false
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('LOGOUT')
    }
  },
  mounted () {
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    isLogged () {
      if (this.$store.state.auth.user) {
        return this.$store.state.auth.user.id
      }
    },
    isProfileSection () {
      return this.$route.name.startsWith('profile')
    },
    isSubjectSection () {
      return this.$route.name.startsWith('purchased-libraries') || this.$route.name.startsWith('libraries')
    },
    isAdminSection () {
      return this.$route.name.startsWith('admin')
    }
  },
  watch: {
    '$route' () {
      this.$bvModal.hide('header-modal')
    }
  }
}
</script>